import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorCorporateOrganizationSearch = () => {
  const corporateOrganizationSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/corporate/organization/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { corporateOrganizationSearch }
}

export default InteractorCorporateOrganizationSearch
